//https://github.com/zloirock/core-js/blob/fe7c8511a6d27d03a9b8e075b3351416aae95c58/packages/core-js/stable/index.js
/* eslint-env browser, node */
/* global globalThis */
import "core-js/stable";
import "regenerator-runtime/runtime";

(function () {
  if (typeof globalThis.__webpack_share_scopes__ !== "object") {
    // Provide an empty default share scope so container.init(...) doesn't crash
    globalThis.__webpack_share_scopes__ = { default: {} };
  }
  if (typeof globalThis.__webpack_init_sharing__ !== "function") {
    // Host-side sharing init is a no-op in a non-webpack host
    globalThis.__webpack_init_sharing__ = function () {
      return Promise.resolve();
    };
  }
})();
